import httpClient from "../../../../../shared/api/httpClient";
import { qs } from "../../../../../shared/api/qs";

export const getPreparedProducts = async (
  { page = 1, limit = 25, name, sector, isActive, signal } = {}
) => {
  const query = qs({ page, limit, name, sector, isActive });
  return httpClient.get(`/stock/prepared-products${query}`, { signal });
};

export const getPreparedProduct = async (preparedProductId, { signal } = {}) => {
  if (!preparedProductId) throw new Error("El ID del elaborado es requerido");
  return httpClient.get(`/stock/prepared-products/${preparedProductId}`, { signal });
};

export const getPreparedProductRecipes = async (
  preparedProductId,
  { page = 1, limit = 1, signal } = {}
) => {
  if (!preparedProductId) throw new Error("El ID del elaborado es requerido");

  const query = qs({ page, limit });
  return httpClient.get(`/stock/prepared-products/${preparedProductId}/recipes${query}`, { signal });
};

export const getPreparedProductRecipe = async (preparedProductId, recipeId, { signal } = {}) => {
  if (!preparedProductId) throw new Error("El ID del elaborado es requerido");
  if (!recipeId) throw new Error("El ID de la receta es requerido");

  return httpClient.get(`/stock/prepared-products/${preparedProductId}/recipes/${recipeId}`, { signal });
};

export const createPreparedProductWithRecipe = async (data) => {
  return httpClient.post("/stock/prepared-products/with-recipe", data);
};

export const patchPreparedProduct = async (preparedProductId, data) => {
  if (!preparedProductId) throw new Error("El ID del elaborado es requerido");
  return httpClient.patch(`/stock/prepared-products/${preparedProductId}`, data);
};

export const patchPreparedProductWithNewRecipe = async (preparedProductId, data) => {
  if (!preparedProductId) throw new Error("El ID del elaborado es requerido");
  return httpClient.patch(`/stock/prepared-products/${preparedProductId}/with-recipe`, data);
};

export const patchPreparedProductWithRecipe = async (
  preparedProductId,
  recipeId,
  data,
) => {
  if (!preparedProductId) throw new Error("El ID del elaborado es requerido");
  if (!recipeId) throw new Error("El ID de la receta es requerido");
  return httpClient.patch(
    `/stock/prepared-products/${preparedProductId}/recipes/${recipeId}/full`,
    data,
  );
};
